import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'videos',
    label: 'Videos',
    type: types.ARRAY,
    children: [
      {
        key: 'video_url',
        label: 'Video Url',
        type: types.TEXT
      },
      {
        key: 'cover_image',
        label: 'Cover Image',
        type: types.TEXT
      },
      {
        key: 'youtube_link',
        label: 'YouTube Video Link (Empty video url field to use YouTube link)',
        type: types.TEXT
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      }
    ]
  }
];

const defaultProps = {
  videos: [
    {
      video_url: '',
      cover_image: 'https://genesis-cdn.ff.com/product/video%20covers/ff-91-exterior-sculpted-for-revolution-video-cover.jpg',
      youtube_link: 'https://www.youtube.com/watch?v=fIvxFE-TgPY',
      title: 'FF 91 EXTERIOR | SCULPTED FOR REVOLUTION'
    },
    {
      video_url: '',
      cover_image: 'https://genesis-cdn.ff.com/product/video%20covers/testing-ff-91-pikes-peak-video-cover.jpg',
      youtube_link: 'https://www.youtube.com/watch?v=blg89TIqRW8',
      title: 'FF 91 EXTERIOR | SCULPTED FOR REVOLUTION'
    }
  ]
};

export default {
  title: 'Video Two Ups',
  id: 'VideoTwoUps',
  propsSchema,
  defaultProps
};
